import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr, StatusBadge } from "@/lib/api";
import { PageHead, Panel } from "@/admin/ui";

const Stat = ({ label, value, tone, id, to }) => (
  <Link to={to} className={`rounded-[22px] p-5 sm:p-6 border border-plum/10 ${tone} hover:-translate-y-0.5 transition-transform`} data-testid={`stat-${id}`}>
    <p className="text-[13px] font-extrabold uppercase tracking-[0.14em] opacity-70">{label}</p>
    <p className="font-display text-[40px] sm:text-[46px] font-semibold leading-none mt-3" data-testid={`stat-${id}-value`}>{value}</p>
  </Link>
);

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="h-64 rounded-[22px] bg-white animate-pulse" />;
  return (
    <div data-testid="admin-dashboard">
      <PageHead title="Dashboard" sub="A quick look at your store today." />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
        <Stat id="paid-revenue" label="Paid revenue" value={inr(s.paid_revenue)} tone="bg-plum text-pearl" to="/admin/payments" />
        <Stat id="paid-orders" label="Paid orders" value={s.paid_orders} tone="bg-[#DDEDE6] text-emerald" to="/admin/orders" />
        <Stat id="pending-payments" label="Pending payments" value={s.pending_payments} tone="bg-[#FBEFD9] text-[#7A5310]" to="/admin/payments" />
        <Stat id="today-orders" label="Today's orders" value={s.today_orders} tone="bg-white" to="/admin/orders" />
        <Stat id="products" label="Products" value={s.products} tone="bg-lilac" to="/admin/products" />
      </div>
      {s.under_verification > 0 && (
        <Link to="/admin/payments" className="mt-6 flex items-center justify-between rounded-[16px] bg-sapphire text-white p-5 font-bold" data-testid="verify-alert">
          {s.under_verification} payment{s.under_verification > 1 ? "s" : ""} waiting for your verification <span className="underline">Review now</span>
        </Link>
      )}
      <Panel title="Recent orders" className="mt-6">
        {s.recent.length === 0 ? <p className="text-plum/60">No orders yet. They will appear here as soon as customers check out.</p> : (
          <ul className="divide-y divide-plum/10">
            {s.recent.map((o) => (
              <li key={o.order_number} className="flex flex-wrap items-center gap-3 py-3">
                <span className="font-extrabold w-24">{o.order_number}</span>
                <span className="flex-1 min-w-[120px]">{o.customer?.name}</span>
                <StatusBadge status={o.payment_status} />
                <span className="font-bold w-24 text-right">{inr(o.total)}</span>
              </li>
            ))}
          </ul>
        )}
      </Panel>
    </div>
  );
}
